import { Payment } from '@mercadopago/sdk-react'
import { Loading, Toast } from 'components'
import { TStatusMP } from 'constants/types'
import { useEffect, useState } from 'react'
import { IPay } from './props'
import { processPayment, registerReference } from './services'
import { Container, HeaderContainer, Img, ImgPayState, Info, PayState, Price, Title, TitlePayState } from './styled'

const Pay = () => {
  const [step, setStep] = useState(1)
  const [result, setResult] = useState<TStatusMP>('pending')
  const [loading, setLoading] = useState<boolean>(false)
  const [createReference, setCreateReference] = useState<{
    amount: number
    preferenceId?: string
  }>({
    amount: 0,
  })

  useEffect(() => {
    registerReference(setLoading, setCreateReference)
  }, [])

  const customization: any = {
    paymentMethods: {
      creditCard: "all",
      debitCard: "all",
    },
  }

  const onSubmit = async (
    { formData }: { formData: IPay }
  ) => {
    processPayment(formData, setStep, setResult)
  }

  const onError = async (error: any) => {
    Toast({
      type: 'error',
      message: error.message || 'Ocurrió un error al procesar el pago'
    })
  }

  const returnFirstStep = () => (
    <>
      {loading && <Loading />}
      {!loading && (
        <>
          <HeaderContainer>
            <Title>El Mejor Test Vocacional</Title>
            <Info>
              <strong>Recuerda:</strong> <br />
              El correo electrónico que ingreses será el medio por el cual te enviaremos el enlace para que puedas realizar el test.
            </Info>
            <Img src='https://consultoriomga.com/test-vocacional-react/img/logo_mga.png' alt="logo_mga" />
            <Price>Costo S/. {createReference.amount.toFixed(2)}</Price>
          </HeaderContainer>

          <Payment
            locale='es-PE'
            initialization={createReference}
            customization={customization}
            onSubmit={onSubmit}
            onError={onError}
          />
        </>
      )}
    </>
  )

  const returnSecondStep = () => {
    let body: JSX.Element | null = null

    if (result === 'pending' || result === 'in_process' || result === 'in_mediation') {
      body = (
        <>
          <TitlePayState>Pago pendiente</TitlePayState>
          <ImgPayState src='https://consultoriomga.com/test-vocacional-react/img/pay.png' />
          <p>Su pago aun no tiene una respuesta, acerquese a pagar y en caso ya lo realizo le avisaremos por su correo.</p>
        </>
      )

    }

    if (result === 'approved') {
      body = (
        <>
          <TitlePayState>Pago aprobado ✅</TitlePayState>
          <ImgPayState src='https://consultoriomga.com/test-vocacional-react/img/pay.png' />
          <p>Su pago ha sido aprobado exitosamente, por favor verifique su correo donde se le enviara las instrucciones para su test.</p>
        </>
      )
    }

    if (result === 'cancelled' || result === 'rejected' || result === 'refunded' || result === 'charged_back' || result === 'authorized') {
      body = (
        <>
          <TitlePayState>Pago cancelado ❌</TitlePayState>
          <ImgPayState src='https://consultoriomga.com/test-vocacional-react/img/pay.png' />
          <p>Su pago no fue aprobado, para más detalle verifique su correo o contacte al administrador.</p>
        </>
      )
    }

    return (
      <PayState>
        {body}
      </PayState>
    )
  }


  return (
    <Container>
      {step === 1 && returnFirstStep()}
      {step === 2 && returnSecondStep()}
    </Container>
  )
}

export default Pay